<template>
  <div class="px-3 py-6 md:px-6">
    <PurchaseFlowTabs
      :tabs="beneficialOwnerTabs"
      :active-index="currentSubstepIndex"
      @tab-click="handleTabClick"
    />
    <div :class="false ? 'h-0' : 'h-4'"></div>

    <Form
      :schema_array="schemaToUse"
      :state_object="stateObject"
      variant="secondary"
      class="mt-5 md:mt-6"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useSchemaStore, usePurchaseFlowStore } from "@/stores";
import { Form } from "@/components";
import PurchaseFlowTabs from "./PurchaseFlowTabs.vue";

const schemaStore = useSchemaStore();
const purchaseFlowStore = usePurchaseFlowStore();

const beneficialOwnerTabs = [
  { name: "Personal Information", schema_group: "Personal Information" },
  { name: "Residential Address", schema_group: "Residential Address" },
  { name: "ID Information", schema_group: "ID Information" },
];

const localSubstep = ref(1);

const currentSubstepIndex = computed(() => localSubstep.value - 1);
const schemaToUse = computed(() => getSchemaForSubstep(currentSubstepIndex.value));
const stateObject = computed(() =>
  beneficialOwnerTabs[currentSubstepIndex.value]?.name === "ID Information"
    ? purchaseFlowStore.beneficial_owner_to_add.id_info
    : purchaseFlowStore.beneficial_owner_to_add
);
const isLastSubstep = computed(() => currentSubstepIndex.value === beneficialOwnerTabs.length - 1);

function getSchemaForSubstep(index) {
  const tab = beneficialOwnerTabs[index];
  return purchaseFlowStore.accredited_ben_owner_contact_personal_info_schema.find(
    (schema) => schema.group_name === tab?.schema_group
  )?.fields;
}

function handleTabClick(index) {
  const targetSubstep = index + 1;
  const currentSubstep = localSubstep.value;

  if (targetSubstep <= currentSubstep) {
    localSubstep.value = targetSubstep;
    return;
  }

  const result = validateRange(currentSubstep - 1, index);
  if (!result.proceed) {
    localSubstep.value = result.failedAt + 1;
    return;
  }
  localSubstep.value = targetSubstep;
  return;
}

function validateSubstep(index) {
  const schema = getSchemaForSubstep(index);

  const result = schemaStore.validateFields(
    purchaseFlowStore.beneficial_owner_to_add,
    schema,
    purchaseFlowStore.beneficial_owner_to_add.record_id,
    true
  );

  return {
    proceed: result.proceed,
    errors: result.invalid_fields,
    tabName: beneficialOwnerTabs[index]?.name,
    error_messages: result.error_messages,
    field_errors: result.field_errors,
  };
}

function validateRange(fromIndex, toIndex) {
  for (let i = fromIndex; i < toIndex; i++) {
    const result = validateSubstep(i);
    if (!result.proceed) {
      return {
        proceed: false,
        failedAt: i,
        tabName: result.tabName,
        errors: result.errors,
      };
    }
  }
  return { proceed: true };
}

defineExpose({
  validate() {
    const result = validateSubstep(currentSubstepIndex.value);
    // if (!result.proceed) console.log("Validation failed:", result.errors);
    return result;
  },
  goToNextSubstep() {
    if (currentSubstepIndex.value < beneficialOwnerTabs.length - 1) {
      localSubstep.value++;
      return true;
    }
    return false;
  },
  isLastSubstep,
});
</script>
